{
  "settings": {
    "sections": {
      "booking": {
        "label": "Prise de rendez-vous en ligne",
        "hint": "Les patients qui réservent eux-mêmes, et vos jours d’absence, dans chaque clinique"
      }
    },
    "onlineBooking": {
      "regionLabel": "Prise de rendez-vous en ligne dans vos cliniques",
      "cardSubtitle": "Les patients réservent eux-mêmes dans l’application patient et sur votre page",
      "unnamedClinic": "Clinique sans nom",
      "loadFailed": "Les réglages de prise de rendez-vous en ligne ne sont pas disponibles.",
      "saved": "Réglage de prise de rendez-vous en ligne enregistré.",
      "saveFailed": "Le réglage n’a pas été enregistré. Veuillez réessayer.",
      "allow": {
        "label": "Les patients peuvent réserver eux-mêmes en ligne",
        "impact": "Désactivé, aucun créneau en ligne ne vous est proposé dans cette clinique, ni dans l’application patient ni sur votre page. Les rendez-vous pris par l’accueil ne changent pas."
      },
      "horizon": {
        "label": "Jusqu’à combien de jours à l’avance",
        "unit": "jours",
        "placeholder": "La limite de la clinique",
        "clinicCap": "Limite de la clinique : {{days}} jours",
        "effective": "Les patients peuvent désormais réserver jusqu’à {{days}} jours à l’avance.",
        "effectiveNone": "Avec la limite actuelle de la clinique, les patients ne peuvent pas réserver en ligne pour l’instant.",
        "capped": "Votre nombre dépasse la limite de la clinique : ce sont ses {{days}} jours qui s’appliquent.",
        "paused": "Votre prise de rendez-vous en ligne dans cette clinique est suspendue.",
        "invalid": "Saisissez un nombre de 1 à 365, ou laissez vide pour appliquer la limite de la clinique."
      },
      "warnings": {
        "noPresence": "Vos horaires de présence dans cette clinique ne sont pas enregistrés ; aucune prise de rendez-vous en ligne n’est proposée.",
        "noPresenceHint": "C’est l’accueil de la clinique qui enregistre vos horaires.",
        "clinicClosed": "Cette clinique n’accepte pas de réservations en ligne de patients pour le moment.",
        "clinicClosedHint": "Votre réglage s’appliquera dès que la clinique activera la prise de rendez-vous en ligne."
      },
      "empty": {
        "title": "Vous n’êtes membre d’aucune clinique",
        "hint": "La prise de rendez-vous en ligne se règle pour les cliniques où votre adhésion a été acceptée.",
        "action": "Aller aux cliniques"
      },
      "daysOff": {
        "title": "Jours d’absence",
        "hint": "Ces jours-là, ni les patients ni l’accueil ne peuvent vous réserver dans cette clinique. Les rendez-vous déjà pris ne changent pas.",
        "add": "Ajouter un jour d’absence",
        "empty": "Aucun jour d’absence à venir.",
        "emptyHint": "Indiquez les jours où vous êtes absent : voyage, congrès, maladie.",
        "loadFailed": "Les jours d’absence ne sont pas disponibles.",
        "wholeDay": "Toute la journée",
        "hours": "{{start}} à {{end}}",
        "range": "{{from}} au {{to}}",
        "remove": "Supprimer",
        "removeAria": "Supprimer l’absence {{range}}",
        "removeTitle": "Supprimer le jour d’absence",
        "removeBody": "Supprimer l’absence {{range}} à « {{clinic}} » ? Une fois supprimée, on pourra de nouveau vous réserver ces jours-là.",
        "removeConfirm": "Supprimer",
        "removed": "Jour d’absence supprimé.",
        "removeFailed": "Le jour d’absence n’a pas été supprimé."
      },
      "dayOff": {
        "title": "Ajouter un jour d’absence",
        "subtitle": "À « {{clinic}} »",
        "from": "Du",
        "to": "Au (facultatif)",
        "toHint": "Laissez vide pour ce seul jour.",
        "span": "Durée",
        "spanWhole": "Toute la journée",
        "spanPart": "Une partie de la journée",
        "start": "De",
        "end": "Jusqu’à",
        "partHint": "Ces heures s’appliquent à chaque jour de la période.",
        "reason": "Motif (facultatif)",
        "reasonPlaceholder": "p. ex. un congrès",
        "submit": "Enregistrer l’absence",
        "saveFailed": "Le jour d’absence n’a pas été enregistré.",
        "errors": {
          "from": "Choisissez la date de début.",
          "order": "La date de fin ne peut pas précéder la date de début.",
          "range": "Une absence dure au plus 366 jours.",
          "past": "Une absence ne peut pas se terminer avant aujourd’hui.",
          "hours": "L’heure de début doit précéder l’heure de fin."
        }
      }
    }
  },
  "errors": {
    "bff": {
      "onboarding": {
        "clinicListUnavailable": "La liste des cliniques n’est pas disponible."
      },
      "onlineBooking": {
        "notMember": "Vous n’êtes pas membre accepté de cette clinique.",
        "settingsLoad": "Les réglages de prise de rendez-vous en ligne n’ont pas pu être chargés.",
        "settingsSave": "Les réglages de prise de rendez-vous en ligne n’ont pas pu être enregistrés.",
        "horizonInvalid": "Le nombre de jours doit être compris entre 1 et 365 ; laissez vide pour la limite de la clinique.",
        "invalid": "Les informations saisies ne sont pas valides.",
        "daysOffLoad": "Les jours d’absence n’ont pas pu être chargés.",
        "dayOffSave": "Le jour d’absence n’a pas pu être enregistré.",
        "dayOffRemove": "Le jour d’absence n’a pas pu être supprimé.",
        "dayOffNotFound": "Ce jour d’absence est introuvable.",
        "dayOffDate": "La date de l’absence n’est pas valide.",
        "dayOffOrder": "La date de fin de l’absence ne peut pas précéder sa date de début.",
        "dayOffRange": "Une absence dure au plus 366 jours.",
        "dayOffPast": "Une absence ne peut pas se terminer avant aujourd’hui.",
        "dayOffMinutes": "L’heure de début de l’absence doit précéder son heure de fin."
      }
    }
  }
}
